import { render } from "./Configurations.vue?vue&type=template&id=77a2d629"
import script from "./Configurations.vue?vue&type=script&lang=js"
export * from "./Configurations.vue?vue&type=script&lang=js"

import "./Configurations.vue?vue&type=style&index=0&id=77a2d629&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__